import axiosInstance from "../axiosClient";
import { platformAnalytics, userAnalytics, consultantAnalytics, analyticsDetail } from "../config";

const isValidDate = (date) => /^\d{4}-\d{2}-\d{2}$/.test(date);

export const getPlatformAnalytics = async (date) => {
  let queryParams = [];
  if (date && isValidDate(date)) queryParams.push(`date=${encodeURIComponent(date)}`);
  const queryString = queryParams.length > 0 ? `?${queryParams.join("&")}` : "";
  return await axiosInstance.get(`${platformAnalytics}${queryString}`);
};

export const getUserAnalytics = async (user_id, date) => {
  let queryParams = [];
  if (user_id) queryParams.push(`user_id=${encodeURIComponent(user_id)}`);
  if (date && isValidDate(date)) queryParams.push(`date=${encodeURIComponent(date)}`);
  const queryString = queryParams.length > 0 ? `?${queryParams.join("&")}` : "";
  return await axiosInstance.get(`${userAnalytics}${queryString}`);
};

export const getConsultantAnalytics = async (consultant_id, date) => {
  let queryParams = [];
  if (consultant_id) queryParams.push(`consultant_id=${encodeURIComponent(consultant_id)}`);
  if (date && isValidDate(date)) queryParams.push(`date=${encodeURIComponent(date)}`);
  const queryString = queryParams.length > 0 ? `?${queryParams.join("&")}` : "";
  return await axiosInstance.get(`${consultantAnalytics}${queryString}`);
};

export const getAnalyticsDetail = async (type, date, limit, start_key) => {
  let queryParams = [];
  if (type) queryParams.push(`type=${encodeURIComponent(type)}`);
  if (date && /^\d{4}-\d{2}-\d{2}$/.test(date)) queryParams.push(`date=${encodeURIComponent(date)}`);
  if (limit) queryParams.push(`limit=${encodeURIComponent(limit)}`);
  if (start_key) queryParams.push(`start_key=${encodeURIComponent(start_key)}`);
  const queryString = queryParams.length > 0 ? `?${queryParams.join("&")}` : "";
  return await axiosInstance.get(`${analyticsDetail}${queryString}`);
};
